import store from '@state/store'
import router from '@router/index'

export const DISPLAYMODE = {
  START: 0,
  START_OPEN: 1,
  CONDITION: 2,
}

export const prefectures = {
  '01': '北海道',
  '02': '青森県',
  '03': '岩手県',
  '04': '宮城県',
  '05': '秋田県',
  '06': '山形県',
  '07': '福島県',
  '08': '茨城県',
  '09': '栃木県',
  '10': '群馬県',
  '11': '埼玉県',
  '12': '千葉県',
  '13': '東京都',
  '14': '神奈川県',
  '15': '新潟県',
  '16': '富山県',
  '17': '石川県',
  '18': '福井県',
  '19': '山梨県',
  '20': '長野県',
  '21': '岐阜県',
  '22': '静岡県',
  '23': '愛知県',
  '24': '三重県',
  '25': '滋賀県',
  '26': '京都府',
  '27': '大阪府',
  '28': '兵庫県',
  '29': '奈良県',
  '30': '和歌山県',
  '31': '鳥取県',
  '32': '島根県',
  '33': '岡山県',
  '34': '広島県',
  '35': '山口県',
  '36': '徳島県',
  '37': '香川県',
  '38': '愛媛県',
  '39': '高知県',
  '40': '福岡県',
  '41': '佐賀県',
  '42': '長崎県',
  '43': '熊本県',
  '44': '大分県',
  '45': '宮崎県',
  '46': '鹿児島県',
  '47': '沖縄県',
}
export const areas = [
  { code: '101', name: '北海道', prefectures: ['01'] },
  {
    code: '102',
    name: '東北',
    prefectures: ['02', '03', '04', '05', '06', '07'],
  },
  {
    code: '103',
    name: '関東甲信越',
    prefectures: ['08', '09', '10', '11', '12', '13', '14', '15', '19', '20'],
  },
  {
    code: '104',
    name: '東海・北陸',
    prefectures: ['16', '17', '18', '21', '22', '23', '24'],
  },
  {
    code: '105',
    name: '近畿',
    prefectures: ['25', '26', '27', '28', '29', '30'],
  },
  { code: '106', name: '中国', prefectures: ['31', '32', '33', '34', '35'] },
  { code: '107', name: '四国', prefectures: ['36', '37', '38', '39'] },
  {
    code: '108',
    name: '九州・沖縄',
    prefectures: ['40', '41', '42', '43', '44', '45', '46', '47'],
  },
  {
    code: '999',
    name: 'オンライン優待',
    prefectures: [],
  },
]
export const genre = [
  { code: 'H', name: 'グルメ' },
  { code: 'J', name: 'ショッピング' },
  { code: 'E', name: '温泉・入浴施設' },
  { code: 'C', name: '観光名所、動物園など' },
  { code: 'D', name: '美術館、博物館' },
  { code: 'M', name: '道の駅' },
  { code: 'L', name: 'ガソリンスタンド' },
  { code: 'G', name: 'アミューズメント' },
  { code: 'B', name: '遊園地・テーマパーク' },
  { code: 'K', name: '暮らし' },
  { code: 'F', name: 'アウトドア' },
  { code: 'Q', name: 'SA・PA（サービスエリア）' },
  { code: 'A', name: '宿泊' },
  { code: 'N', name: '旅行' },
  { code: 'P', name: 'カルチャー' },
  { code: 'Y', name: 'その他' },
  { code: 'A1', name: 'ホテル' },
  { code: 'A2', name: '旅館' },
  { code: 'A0', name: '公共の宿・民宿・ペンション他' },
  { code: 'A5', name: 'キャンプ場' },
  { code: 'A6', name: 'ペットと泊まれる宿' },
  { code: 'B1', name: '遊園地・テーマパーク' },
  { code: 'B0', name: 'プール' },
  { code: 'C0', name: '史跡・庭園' },
  { code: 'C2', name: '遊覧船・観光船' },
  { code: 'C3', name: 'ロープウェイ' },
  { code: 'C6', name: '植物園・公園' },
  { code: 'C7', name: '水族館・動物園・牧場' },
  { code: 'C8', name: '展望台・タワー' },
  { code: 'C9', name: '酒蔵・ワイナリー' },
  { code: 'CA', name: 'その他' },
  { code: 'D1', name: '美術館' },
  { code: 'D0', name: '博物館' },
  { code: 'D3', name: '資料館' },
  { code: 'D4', name: '科学館' },
  { code: 'D5', name: 'プラネタリウム他' },
  { code: 'E1', name: '温泉・入浴施設' },
  { code: 'F1', name: 'キャンプ・バーベキュー' },
  { code: 'F2', name: 'スキー・スノーボード' },
  { code: 'F0', name: 'スケート' },
  { code: 'F3', name: 'ゴルフ' },
  { code: 'F4', name: '味覚狩り' },
  { code: 'F5', name: '釣り' },
  { code: 'FY', name: 'その他' },
  { code: 'G4', name: 'ボウリング' },
  { code: 'G5', name: 'カラオケ' },
  { code: 'G3', name: '映画館' },
  { code: 'G1', name: 'スポーツ観戦' },
  { code: 'G2', name: 'ホール・劇場' },
  { code: 'G0', name: '音楽鑑賞・オーケストラ' },
  { code: 'G6', name: 'ネットカフェ' },
  { code: 'G7', name: 'ゲームセンター' },
  { code: 'G8', name: 'キッズランド' },
  { code: 'G9', name: '動画・音楽・配信サービス' },
  { code: 'GY', name: 'その他' },
  { code: 'H0', name: '和食' },
  { code: 'H5', name: '洋食・西洋料理' },
  { code: 'H6', name: '中華料理' },
  { code: 'H7', name: 'カレー・アジア・エスニック' },
  { code: 'H2', name: 'カフェ・スイーツ' },
  { code: 'H3', name: 'ファストフード' },
  { code: 'H8', name: 'ファミレス' },
  { code: 'H9', name: '焼肉・しゃぶしゃぶ・ステーキ' },
  { code: 'HA', name: 'ビュッフェ・バイキング' },
  { code: 'HB', name: '回転寿司・すし' },
  { code: 'HC', name: '麺（ラーメン、うどん、そば）' },
  { code: 'HD', name: '居酒屋・ダイニング' },
  { code: 'HE', name: '宅配ピザ・デリバリー' },
  { code: 'HF', name: '弁当・惣菜・テイクアウト' },
  { code: 'HY', name: 'その他' },
  { code: 'J0', name: '家電、家具、インテリア' },
  { code: 'J3', name: '百貨店、ショッピングセンター' },
  { code: 'J4', name: 'ドラッグストア・メガネ・コンタクトレンズ' },
  { code: 'J6', name: 'ファッション・アクセサリー・時計・雑貨' },
  { code: 'J7', name: 'ベビー・キッズ用品' },
  { code: 'J8', name: '手芸、工芸' },
  { code: 'J9', name: 'カー用品' },
  { code: 'JA', name: 'ペット用品' },
  { code: 'JB', name: 'スポーツ・自転車・アウトドア用品' },
  { code: 'JC', name: 'アウトレット' },
  { code: 'JD', name: 'リサイクル・ディスカウントショップ' },
  { code: 'JE', name: 'みやげ品販売' },
  { code: 'JY', name: 'その他' },
  { code: 'K3', name: '美・理容室' },
  { code: 'K0', name: 'ハウスクリーニング・家事代行' },
  { code: 'K2', name: 'クリーニング店' },
  { code: 'K7', name: '洋服仕立て直し・リメイク' },
  { code: 'K8', name: '靴・鍵' },
  { code: 'K5', name: '引越し' },
  { code: 'K1', name: '駐車場' },
  { code: 'K9', name: 'レンタル・WiFi他' },
  { code: 'K4', name: 'ヨガ・スポーツクラブ・プール' },
  { code: 'KA', name: 'フォトスタジオ・写真館' },
  { code: 'KB', name: '健診・人間ドック' },
  { code: 'KY', name: 'その他' },
  { code: 'L1', name: 'ＥＮＥＯＳ' },
  { code: 'L2', name: '出光' },
  { code: 'L3', name: 'カーエネクス' },
  { code: 'L4', name: 'コスモ石油' },
  { code: 'L5', name: '昭和シェル石油' },
  { code: 'L6', name: 'ＳＯＬＡＴＯ' },
  // { code: 'L7', name: 'Ｍｅ' },
  { code: 'L8', name: 'キグナス石油' },
  { code: 'L9', name: 'ナヴィ' },
  { code: 'LA', name: 'ゼネラル' },
  // { code: 'LB', name: 'エッソ' },
  // { code: 'LC', name: 'モービル' },
  { code: 'LD', name: 'ＪＡ－ＳＳ' },
  // { code: 'LE', name: 'ぺトラス' },
  { code: 'LY', name: 'その他' },
  { code: 'M1', name: '道の駅' },
  { code: 'N1', name: 'フェリー' },
  { code: 'N2', name: 'レンタカー' },
  { code: 'N3', name: 'レンタルバイク' },
  { code: 'N4', name: 'レンタルサイクル' },
  { code: 'N5', name: 'パッケージ旅行' },
  { code: 'N6', name: '旅行関連用品 他' },
  // { code: 'NY', name: 'その他' },
  { code: 'P1', name: 'カルチャーセンター・習い事' },
  { code: 'P2', name: '体験' },
  // { code: 'P3', name: 'オーケストラ' },
  { code: 'PY', name: 'その他' },

  { code: 'Q1', name: 'SA・PA（サービスエリア）' },
  { code: 'Y1', name: 'マイカー回送' },
  { code: 'Y2', name: '自動車学校' },
  // { code: 'YJ', name: 'JAF支部' },
  { code: 'YY', name: 'その他' },
]

export const state = {
  existCoupon:
    (sessionStorage.getItem('COUPON_FLAG') &&
      sessionStorage.getItem('COUPON_FLAG') == 1) ||
    false,
  isLimited:
    (sessionStorage.getItem('YUUTAI_FLAG') &&
      sessionStorage.getItem('YUUTAI_FLAG') == 1) ||
    false,
  isOnline:
    (sessionStorage.getItem('WEB_FLAG') &&
      sessionStorage.getItem('WEB_FLAG') == 1) ||
    false,
  isNowAround:
    (sessionStorage.getItem('NOW_AROUND') &&
      sessionStorage.getItem('NOW_AROUND') == 1) ||
    false,
  isPointSearch:
    (sessionStorage.getItem('POINT_SEARCH') &&
      sessionStorage.getItem('POINT_SEARCH') == 1) ||
    false,
  isPremiam:
    (sessionStorage.getItem('PREMIAM_FLAG') &&
      sessionStorage.getItem('PREMIAM_FLAG') == 1) ||
    false,
  isNewShop:
    (sessionStorage.getItem('NEW_FLAG') &&
      sessionStorage.getItem('NEW_FLAG') == 1) ||
    false,
  excludeBrandFlag: sessionStorage.getItem('EXCLUDE_BRAND_FLAG') === '1',
  lon: sessionStorage.getItem('LON') || '',
  lat: sessionStorage.getItem('LAT') || '',
  genreCode: sessionStorage.getItem('GENRE') || '',
  searchTagId: sessionStorage.getItem('SEARCH_TAG_ID') || '',
  brandId: sessionStorage.getItem('BRAND_ID') || '',
  areaCode: sessionStorage.getItem('AREA') || '',
  searchWord: sessionStorage.getItem('SEARCH_WORD') || '',
  tempExistCoupon:
    (sessionStorage.getItem('TEMP_COUPON_FLAG') &&
      sessionStorage.getItem('TEMP_COUPON_FLAG') == 1) ||
    false,
  tempIsLimited:
    (sessionStorage.getItem('TEMP_YUUTAI_FLAG') &&
      sessionStorage.getItem('TEMP_YUUTAI_FLAG') == 1) ||
    false,
  tempIsOnline:
    (sessionStorage.getItem('TEMP_WEB_FLAG') &&
      sessionStorage.getItem('TEMP_WEB_FLAG') == 1) ||
    false,
  tempIsNowAround:
    (sessionStorage.getItem('TEMP_NOW_AROUND') &&
      sessionStorage.getItem('TEMP_NOW_AROUND') == 1) ||
    false,
  tempIsPointSearch:
    (sessionStorage.getItem('TEMP_POINT_SEARCH') &&
      sessionStorage.getItem('TEMP_POINT_SEARCH') == 1) ||
    false,
  tempIsPremiam:
    (sessionStorage.getItem('TEMP_PREMIAM_FLAG') &&
      sessionStorage.getItem('TEMP_PREMIAM_FLAG') == 1) ||
    false,
  tempIsNewShop:
    (sessionStorage.getItem('TEMP_NEW_FLAG') &&
      sessionStorage.getItem('TEMP_NEW_FLAG') == 1) ||
    false,
  tempGenre: sessionStorage.getItem('TEMP_GENRE') || '',
	tempPrefecture: sessionStorage.getItem('TEMP_PREFECTURE') || '',
	tempMunicipality: sessionStorage.getItem('TEMP_MUNICIPALITY') || '',
  tempSearchWord: sessionStorage.getItem('TEMP_SEARCH_WORD') || '',
  displayMode: sessionStorage.getItem('DISPLAY_MODE') || DISPLAYMODE.START,
}

export const mutations = {
  SET_EXISTCOUPON(state, newValue) {
    state.existCoupon = newValue
    sessionStorage.setItem('COUPON_FLAG', newValue ? '1' : '')
  },
  SET_ISLIMITED(state, newValue) {
    state.isLimited = newValue
    sessionStorage.setItem('YUUTAI_FLAG', newValue ? '1' : '')
  },
  SET_ISONLINE(state, newValue) {
    state.isOnline = newValue
    sessionStorage.setItem('WEB_FLAG', newValue ? '1' : '')
  },
  SET_GENRECODE(state, newValue) {
    state.genreCode = newValue
    sessionStorage.setItem('GENRE', newValue)
  },
  SET_AREACODE(state, newValue) {
    state.areaCode = newValue
    sessionStorage.setItem('AREA', newValue)
  },
  SET_SEARCHTAGID(state, newValue) {
    state.searchTagId = newValue
    sessionStorage.setItem('SEARCH_TAG_ID', newValue)
  },
  SER_BRANDID(state, newValue) {
    state.brandId = newValue
    sessionStorage.setItem('BRAND_ID', newValue)
  },
  SET_SEARCHWORD(state, newValue) {
    state.searchWord = newValue
    sessionStorage.setItem('SEARCH_WORD', newValue)
  },
  SET_ISPREMIAM(state, newValue) {
    state.isPremiam = newValue
    sessionStorage.setItem('PREMIAM_FLAG', newValue ? '1' : '')
  },
  SET_ISNEWSHOP(state, newValue) {
    state.isNewShop = newValue
    sessionStorage.setItem('NEW_FLAG', newValue ? '1' : '')
  },
  SET_DISPLAYMODE(state, newValue) {
    state.displayMode = newValue
    sessionStorage.setItem('DISPLAY_MODE', newValue)
  },
  SET_EXCLUDE_BRAND_FLAG(state, newValue) {
    state.excludeBrandFlag = newValue
    sessionStorage.setItem('EXCLUDE_BRAND_FLAG', newValue ? '1' : '0')
  },
  SET_LON(state, newValue) {
    state.lon = newValue
    sessionStorage.setItem('LON', newValue)
  },
  SET_LAT(state, newValue) {
    state.lat = newValue
    sessionStorage.setItem('LAT', newValue)
  },
  SET_ISNOWAROUND(state, newValue) {
    state.isNowAround = newValue
    sessionStorage.setItem('NOW_AROUND', newValue ? '1' : '')
  },
  SET_ISPOINTSEARCH(state, newValue) {
    state.isPointSearch = newValue
    sessionStorage.setItem('POINT_SEARCH', newValue ? '1' : '')
  },
  SET_TEMPEXISTCOUPON(state, newValue) {
    state.tempExistCoupon = newValue
    sessionStorage.setItem('TEMP_COUPON_FLAG', newValue ? '1' : '')
  },
  SET_TEMPISLIMITED(state, newValue) {
    state.tempIsLimited = newValue
    sessionStorage.setItem('TEMP_YUUTAI_FLAG', newValue ? '1' : '')
  },
  SET_TEMPISONLINE(state, newValue) {
    state.tempIsOnline = newValue
    sessionStorage.setItem('TEMP_WEB_FLAG', newValue ? '1' : '')
  },
  SET_TEMPGENRE(state, newValue) {
    state.tempGenre = newValue
    sessionStorage.setItem('TEMP_GENRE', newValue)
  },
	SET_TEMPPREFECTURE(state, newValue) {
    state.tempPrefecture = newValue
    sessionStorage.setItem('TEMP_PREFECTURE', newValue)
  },
	SET_TEMPMUNICIPALITY(state, newValue) {
    state.tempMunicipality = newValue
    sessionStorage.setItem('TEMP_MUNICIPALITY', newValue)
  },
  SET_TEMPSEARCHWORD(state, newValue) {
    state.tempSearchWord = newValue
    sessionStorage.setItem('TEMP_SEARCH_WORD', newValue)
  },
  SET_TEMPISNOWAROUND(state, newValue) {
    state.tempIsNowAround = newValue
    sessionStorage.setItem('TEMP_NOW_AROUND', newValue ? '1' : '')
  },
  SET_TEMPISPOINTSEARCH(state, newValue) {
    state.tempIsPointSearch = newValue
    sessionStorage.setItem('TEMP_POINT_SEARCH', newValue ? '1' : '')
  },
  SET_TEMPISPREMIAM(state, newValue) {
    state.tempIsPremiam = newValue
    sessionStorage.setItem('TEMP_PREMIAM_FLAG', newValue ? '1' : '')
  },
  SET_TEMPISNEWSHOP(state, newValue) {
    state.tempIsNewShop = newValue
    sessionStorage.setItem('TEMP_NEW_FLAG', newValue ? '1' : '')
  },
}

export const actions = {
  toggleCoupon({ commit, state, rootState }) {
    commit('SET_EXISTCOUPON', !state.existCoupon)
  },
  uncheckCoupon({ commit, state, rootState }) {
    commit('SET_EXISTCOUPON', false)
  },
  checkCoupon({ commit, state, rootState }) {
    commit('SET_EXISTCOUPON', true)
  },
  toggleIsPremiam({ commit, state, rootState }) {
    commit('SET_ISPREMIAM', !state.isPremiam)
  },
  toggleIsNewShop({ commit, state, rootState }) {
    commit('SET_ISNEWSHOP', !state.isNewShop)
  },
  uncheckIsPremiam({ commit, state, rootState }) {
    commit('SET_ISPREMIAM', false)
  },
  uncheckIsNewShop({ commit, state, rootState }) {
    commit('SET_ISNEWSHOP', false)
  },
  checkIsPremiam({ commit, state, rootState }) {
    commit('SET_ISPREMIAM', true)
  },
  checkIsNewShop({ commit, state, rootState }) {
    commit('SET_ISNEWSHOP', true)
  },
  toggleIsLimited({ commit, state, rootState }) {
    commit('SET_ISLIMITED', !state.isLimited)
  },
  uncheckIsLimited({ commit, state, rootState }) {
    commit('SET_ISLIMITED', false)
  },
  checkIsLimited({ commit, state, rootState }) {
    commit('SET_ISLIMITED', true)
  },
  toggleIsOnline({ commit, state, rootState }) {
    commit('SET_ISONLINE', !state.isOnline)
  },
  uncheckIsOnline({ commit, state, rootState }) {
    commit('SET_ISONLINE', false)
  },
  checkIsOnline({ commit, state, rootState }) {
    commit('SET_ISONLINE', true)
  },
  setDisplayMode({ commit, state, rootState }, mode) {
    commit('SET_DISPLAYMODE', mode)
  },
  setGenreCode({ commit, state, rootState }, code) {
    commit('SET_GENRECODE', code)
  },
  setAreaCode({ commit, state, rootState }, code) {
    commit('SET_AREACODE', code)
  },
  setSearchTagId({ commit, state, rootState }, code) {
    commit('SET_SEARCHTAGID', code)
  },
  setBrandId({ commit, state, rootState }, code) {
    commit('SER_BRANDID', code)
  },
  setSearchWord({ commit, state, rootState }, word) {
    commit('SET_SEARCHWORD', word)
  },
  setExcludeBrandFlag({ commit }, flag) {
    commit('SET_EXCLUDE_BRAND_FLAG', flag)
  },
  setLonLat({ commit, state, rootState }, payload) {
    commit('SET_LON', payload.lon)
    commit('SET_LAT', payload.lat)
  },
  setIsNowAround({ commit, state, rootState }, val) {
    commit('SET_ISNOWAROUND', val)
  },
  setIsPointSearch({ commit, state, rootState }, val) {
    commit('SET_ISPOINTSEARCH', val)
  },
  checkPointSearch({ commit, state, rootState }) {
    commit('SET_ISPOINTSEARCH', true)
  },
  uncheckPointSearch({ commit, state, rootState }) {
    commit('SET_ISPOINTSEARCH', false)
  },
  setTempIsLimited({ commit, state, rootState }, val) {
    commit('SET_TEMPISLIMITED', val)
  },
  setTempIsOnline({ commit, state, rootState }, val) {
    commit('SET_TEMPISONLINE', val)
  },
  setTempExistCoupon({ commit, state, rootState }, val) {
    commit('SET_TEMPEXISTCOUPON', val)
  },
  setTempIsPremiam({ commit, state, rootState }, val) {
    commit('SET_TEMPISPREMIAM', val)
  },
  setTempIsNewShop({ commit, state, rootState }, val) {
    commit('SET_TEMPISNEWSHOP', val)
  },
  setTempGenre({ commit, state, rootState }, code) {
    commit('SET_TEMPGENRE', code)
  },
	setTempPrefecture({ commit, state, rootState }, code) {
    commit('SET_TEMPPREFECTURE', code)
  },
	setTempMunicipality({ commit, state, rootState }, code) {
    commit('SET_TEMPMUNICIPALITY', code)
  },
  setTempSearchWord({ commit, state, rootState }, word) {
    commit('SET_TEMPSEARCHWORD', word)
  },
  setTempIsNowAround({ commit, state, rootState }, val) {
    commit('SET_TEMPISNOWAROUND', val)
  },
  setTempIsPointSearch({ commit, state, rootState }, val) {
    commit('SET_TEMPISPOINTSEARCH', val)
  },
  clearSearch({ commit, state, rootState }) {
    commit('SET_ISONLINE', false)
    commit('SET_EXISTCOUPON', false)
    commit('SET_ISLIMITED', false)
    commit('SET_ISPREMIAM', false)
    commit('SET_ISNEWSHOP', false)
    commit('SET_EXCLUDE_BRAND_FLAG', false)
    commit('SET_LON', '')
    commit('SET_LAT', '')
    commit('SET_SEARCHWORD', '')
    commit('SET_AREACODE', '')
    commit('SET_SEARCHTAGID', '')
    commit('SER_BRANDID', '')
    commit('SET_GENRECODE', '')
    commit('SET_ISNOWAROUND', false)
    commit('SET_ISPOINTSEARCH', false)
    commit('SET_TEMPISONLINE', false)
    commit('SET_TEMPISPREMIAM', false)
    commit('SET_TEMPISNEWSHOP', false)
    commit('SET_TEMPEXISTCOUPON', false)
    commit('SET_TEMPISLIMITED', false)
    commit('SET_TEMPSEARCHWORD', '')
		commit('SET_TEMPPREFECTURE', '')
		commit('SET_TEMPMUNICIPALITY', '')
    commit('SET_TEMPGENRE', '')
    commit('SET_TEMPISNOWAROUND', false)
    commit('SET_TEMPISPOINTSEARCH', false)
  },
}

export function genreMainText(code) {
  code = code.slice(0, 1)
  for (var i = 0; i < genre.length; i++) {
    if (genre[i].code === code) {
      return genre[i].name
    }
  }
  return ''
}

export function genreSubText(code) {
  if (code == 'すべて') {
    return code
  }

  if (code.length > 1) {
    for (var i = 0; i < genre.length; i++) {
      if (genre[i].code === code) {
        return genre[i].name
      }
    }
  } else {
    return 'すべて'
  }

  return ''
}

export function genreIndex(code) {
  code = code.slice(0, 1)
  for (var i = 0; i < genre.length; i++) {
    if (genre[i].code === code) {
      return i
    }
  }

  return 0
}

export function subGenreList(code) {
  code = code.slice(0, 1)

  return store.state.genre.genreList.filter((item) => {
    return item.genrecode === code
  })
}

// export function prefectureNameToCode(prefecture) {
//   const prefecture = areas.find((area) => {
//     area.prefectures.indexOf(code) != -1
//   })

//   if (area) {
//     return area.name
//   }

//   return ''
// }

export function getPrefectureCodeFromAreaCode(code) {
  if (!code) {
    return ''
  }
  if (code.length == 3) {
    return code
  }
  const results = code.split(/(\s+)/)
  if (results && results.length > 2) {
    return code.split(/(\s+)/)[2]
  } else {
    return ''
  }
}

export function getMunicipalityFromAreaCode(code) {
  if (!code) {
    return ''
  }
  const results = code.split(/(\s+)/)
  if (results && results.length > 4) {
    return code.split(/(\s+)/)[4]
  } else if (code.length == 3) {
		return ''
	} else if (code.length != 3 && results && results.length > 2) {
		return 'すべて'
	}
}

export function areaText(code) {
  let area

  if (code.length == 3) {
    area = areas.find((area) => {
      return area.code == code
    })
  } else {
    area = areas.find((area) => {
      return area.prefectures.indexOf(code) !== -1
    })
  }

  if (area) {
    return area.name
  }

  return ''
}

export function areaCode(code) {
  let area

  if (code.legnth == 3) {
    area = areas.find((area) => {
      return area.code == code
    })
  } else {
    area = areas.find((area) => {
      return area.prefectures.indexOf(code) !== -1
    })
  }

  if (area) {
    return area.code
  }

  return ''
}

export function prefectureText(code) {
  return prefectures[code]
}

export function areaCodeFromText(text) {
  return areas.find((area) => {
    return area.name == text
  }).code
}

export function areaIndex(code) {
  for (var i = 0; i < areas.length; i++) {
    if (areas[i].prefectures.indexOf(code) !== -1) {
      return i
    }
  }

  return 0
}

export function subPrefectureList(index) {
  return areas[index].prefectures.map((code) => {
    return { code: code, name: prefectures[code] }
  })
}

export function subPrefectureListByCode(code) {
  return areas
    .find((area) => {
      return area.code == code
    })
    .prefectures.map((code) => {
      return { code: code, name: prefectures[code] }
    })
}

export function subGenreListByCode(code) {
  code = code.slice(0, 1)

  return store.state.genre.genreList
    .filter((item) => {
      return item.genrecode === code
    })
    .map((item) => {
      return { code: item.subGenreCode, name: item.subGenreName }
    })
}

export function isConditionEmpty() {
  return (
    !store.state.facilitySearch.isOnline &&
    !store.state.facilitySearch.isLimited &&
    !store.state.facilitySearch.existCoupon &&
    !store.state.facilitySearch.isPremiam &&
    !store.state.facilitySearch.isNewShop &&
    (!store.state.facilitySearch.genreCode ||
      store.state.facilitySearch.genreCode.length === 0) &&
    (!store.state.facilitySearch.areaCode ||
      store.state.facilitySearch.areaCode.length === 0) &&
    (!store.state.facilitySearch.searchWord ||
      store.state.facilitySearch.searchWord.length === 0) &&
    !store.state.facilitySearch.isNowAround &&
    !store.state.facilitySearch.isPointSearch
  )
}

export function toSearchResultWithQuery() {
  const query = generateQuery()

  router.push({
    name: 'search-result',
    query: query,
  })
}

export function toNewEndWithQuery() {
  const query = generateQuery()
  query.type = sessionStorage.getItem('NEW_END_TYPE')

  router.push({
    name: 'newend-facility',
    query: query,
  })
}

export function toSearchTagFacilityWithQuery() {
  const query = generateQuery()
  const searchTagId = store.state.facilitySearch.searchTagId
  router.push({
    name: 'searchTag-facility',
    query: query,
    params: { id: searchTagId },
  })
}

export function toBrandFacilityWithQuery() {
  const query = generateQuery()
  const brandId = store.state.facilitySearch.brandId
  router.push({
    name: 'brand-facility',
    query: query,
    params: { id: brandId },
  })
}

export function toMapWithQuery() {
  const query = generateQuery()

  router.push({
    name: 'map',
    query: query,
  })
}

export function checkGenreValid(code) {
  for (var i = 0; i < genre.length; i++) {
    if (genre[i].code === code) {
      return true
    }
  }

  return false
}

function generateQuery() {
  const query = {}

  if (store.state.facilitySearch.genreCode) {
    query.genre = store.state.facilitySearch.genreCode
  }

  if (store.state.facilitySearch.areaCode) {
		const cnstAreaCode = store.state.facilitySearch.areaCode
		const results = cnstAreaCode.split(/(\s+)/)
		if (results && results.length > 4 && (results[4] == 'すべて' || results[4] == '全域')) {
			// results[4] == 'すべて' はPC版用
			// results[4] == '全域' 　はSP版用
			query.area = cnstAreaCode.replace(results[3] + results[4], "");
			} else {
			query.area = cnstAreaCode
		}
  }

  if (store.state.facilitySearch.searchWord) {
    query.query = store.state.facilitySearch.searchWord
  }

  if (store.state.facilitySearch.isOnline) {
    query.online = 1
  }

  if (store.state.facilitySearch.isLimited) {
    query.limited = 1
  }

  if (store.state.facilitySearch.existCoupon) {
    query.coupon = 1
  }

  if (store.state.facilitySearch.isPremiam) {
    query.premium = 1
  }

  if (store.state.facilitySearch.isNewShop) {
    query.newshop = 1
  }

  if (store.state.facilitySearch.isNowAround) {
    query.nowAround = 1
  }

  if (store.state.facilitySearch.isPointSearch) {
    query.pointSearch = 1
    query.lon = store.state.facilitySearch.lon
    query.lat = store.state.facilitySearch.lat
  }

  return query
}